export const setGlobalTextSize = (size: 'small' | 'medium' | 'large') => {
    const modifiers = {
      small: 0.875,    // 12.5% smaller
      medium: 1,       // normal size
      large: 1.15     // 12.5% larger
    };
    
    // Save to localStorage
    localStorage.setItem('preferredTextSize', size);
    
    // Apply the modifier only to body text
    document.documentElement.style.setProperty('--body-font-size-modifier', modifiers[size].toString());
  };
  
  export const initializeTextSize = () => {
    const savedSize = localStorage.getItem('preferredTextSize') as 'small' | 'medium' | 'large' | null;
    if (savedSize) {
      setGlobalTextSize(savedSize);
    }
  };